import React from 'react';
import { notificationType } from './../shared_proptypes';
import StatusIcon from '../StatusIcon';
import NotificationItemDetails from "../NotificationItemDetails";
import { compact } from "underscore";

function CampaignApplicationNotification({ notification }) {
  let linkConfig;

  if (notification.link) {
    linkConfig = { url: notification.link };
  }
  const buttonConfigs = compact([linkConfig]);

  return (
    <span className="notification-item" data-test-id="notification_template">
      <StatusIcon status={notification.status} />
      <NotificationItemDetails
        orgType={notification.orgType}
        orgName={notification.orgName}
        message={notification.message}
        buttonConfigs={buttonConfigs}/>
    </span>
  );
}

CampaignApplicationNotification.propTypes = {
  notification: notificationType().isRequired
};

export default CampaignApplicationNotification;
